import { extendTailwindMerge as e } from "tailwind-merge";
import { clsx as t } from "clsx";
// src/design/cn.ts
var n = e({ extend: {
	theme: {
		text: ["h1", "label"],
		shadow: ["floating", "overlay"],
		ease: [
			"standard",
			"enter",
			"exit"
		]
	},
	classGroups: {
		z: [{ z: [
			"sticky",
			"chrome",
			"modal",
			"floating",
			"toast",
			"tooltip"
		] }],
		duration: [{ duration: [
			"fast",
			"normal",
			"slow"
		] }]
	}
} });
function r(...e) {
	return n(t(e));
}
export { r as cn };

//# sourceMappingURL=cn.js.map